'use client';

import { useEffect } from 'react';

import { ErrorPageContentClient } from '@module/mdrt-org/shared/page-content-components/error-page-content/error-page-content-client';
import { logException } from '@shared/utils/helpers/error-logging';

type ErrorPageProps = {
  error: Error & { digest?: string };
  reset: () => void;
};

const Error = ({ error, reset }: ErrorPageProps) => {
  useEffect(() => {
    logException(error);
  }, [error]);

  return <ErrorPageContentClient message={error.message} reset={reset} />;
};

export default Error;
